module.exports = __webpack_public_path__ + "img/m_event_page4.c59a10f4.png";